<script>
    export let value;
    
    export let options;
    export let valueProperty = 'value';
    export let labelProperty = 'label';
    export let allLabel = undefined;
    
    export let id;
    export let srLabel = true;
    export let classes = "";
</script>

{#if srLabel}
    <label class="sr-only" for="{id}">{id}</label>
{/if}
<select id="{id}" class="form-control {classes}" bind:value>
    {#if allLabel}
        <option value="">{allLabel}</option>
    {/if}
    {#each options as option}
        <option value="{option[valueProperty]}">{option[labelProperty]}</option>
    {/each}
</select>